import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import { IconButtonComponent } from "@hermes/aphrodite/icon-button";
import { SvgIconComponent } from "@hermes/aphrodite/svg";
import { AddToCartStateModule } from "@hermes/states/add-to-cart";

import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";

import { QuickBuyButtonComponent } from "./components/quick-buy-button/quick-buy-button.component";
import { QuickBuyModalManagerService } from "./services/quick-buy-modal-manager.service";

@NgModule({
    imports: [
        CommonModule,
        IconButtonComponent,
        SvgIconComponent,
        CallToActionComponent,
        AddToCartStateModule,
        SrOnlyNoSnippetDirective,
    ],
    declarations: [QuickBuyButtonComponent],
    exports: [QuickBuyButtonComponent],
    providers: [QuickBuyModalManagerService],
})
export class QuickBuyModule {}
